"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("circle", {
    cx: 167.2,
    cy: 166.7,
    r: 62.5
  }), (0, _core.jsx)("path", {
    d: "M168.4 270.8c-73.5 0-134.3 54.4-144.4 125.1-1.6 10.9 7.1 20.7 18.1 20.7h252.5c11 0 19.7-9.8 18.1-20.7-9.9-70.7-70.7-125.1-144.3-125.1z"
  }), (0, _core.jsx)("circle", {
    cx: 333.8,
    cy: 166.7,
    r: 62.5
  }), (0, _core.jsx)("path", {
    d: "M335.1 270.8c-14.6 0-28.7 2.2-42 6.2 32.1 28.6 54.6 68.1 61 113 1.3 9 .3 18.1-2.4 26.6h109.7c11 0 19.7-9.8 18.1-20.7-10.1-70.7-70.9-125.1-144.4-125.1zM168.4 270.8c-73.5 0-134.3 54.4-144.4 125.1-1.6 10.9 7.1 20.7 18.1 20.7h252.5c11 0 19.7-9.8 18.1-20.7-9.9-70.7-70.7-125.1-144.3-125.1z"
  }));
};

exports.default = _default;